import { render, staticRenderFns } from "./DomainBackToTop.vue?vue&type=template&id=708d4fcd&scoped=true&"
import script from "./DomainBackToTop.vue?vue&type=script&lang=js&"
export * from "./DomainBackToTop.vue?vue&type=script&lang=js&"
import style0 from "./DomainBackToTop.vue?vue&type=style&index=0&id=708d4fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d4fcd",
  null
  
)

export default component.exports